import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { VehicleModelService } from '../services/vehicle-model.service';

@Component({
  selector: 'app-edit-vehicle',
  templateUrl: './edit-vehicle.component.html',
  styleUrl: './edit-vehicle.component.css',
})
export class EditVehicleComponent {
  editForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<EditVehicleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private vehicleService: VehicleModelService,
  ) {
    this.editForm = this.fb.group({
      typevehicle: [data.typevehicle, Validators.required],
      marca: [data.marca, Validators.required],
      modelo: [data.modelo, Validators.required],
      km: [data.km, [Validators.required]],
      plate: [data.plate, Validators.required],
      color: [data.color, Validators.required],
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.editForm.valid) {
      this.vehicleService.updateVehicleModel(this.data._id, this.editForm.value).subscribe((updatedVehicle) => {
        // Close the modal passing the updated vehicle
        this.dialogRef.close(updatedVehicle);
      });
    }
  }
}
